module.exports = "import React from 'react';\nimport Badge from 'material-ui/Badge';\nimport IconButton from 'material-ui/IconButton';\nimport UploadIcon from 'material-ui/svg-icons/file/cloud-upload';\nimport FolderIcon from 'material-ui/svg-icons/file/folder-open';\n\nconst BadgeExampleContent = () => (\n  <div>\n    <Badge\n      badgeContent={<IconButton tooltip=\"Backup\"><UploadIcon /></IconButton>}\n    >\n      <FolderIcon />\n    </Badge>\n    <Badge\n      badgeContent=\"&copy;\"\n      badgeStyle={{fontSize: 20}}\n    >\n      Company Name\n    </Badge>\n  </div>\n);\n\nexport default BadgeExampleContent;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Badge/ExampleContent.js
 ** module id = 939
 ** module chunks = 0
 **/